/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PostPersonsPersonIdImpersonate201ResponseAllOf
 */
export interface PostPersonsPersonIdImpersonate201ResponseAllOf {
    /**
     * 
     * @type {string}
     * @memberof PostPersonsPersonIdImpersonate201ResponseAllOf
     */
    result: string;
}

/**
 * Check if a given object implements the PostPersonsPersonIdImpersonate201ResponseAllOf interface.
 */
export function instanceOfPostPersonsPersonIdImpersonate201ResponseAllOf(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "result" in value;

    return isInstance;
}

export function PostPersonsPersonIdImpersonate201ResponseAllOfFromJSON(json: any): PostPersonsPersonIdImpersonate201ResponseAllOf {
    return PostPersonsPersonIdImpersonate201ResponseAllOfFromJSONTyped(json, false);
}

export function PostPersonsPersonIdImpersonate201ResponseAllOfFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostPersonsPersonIdImpersonate201ResponseAllOf {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'result': json['result'],
    };
}

export function PostPersonsPersonIdImpersonate201ResponseAllOfToJSON(value?: PostPersonsPersonIdImpersonate201ResponseAllOf | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'result': value.result,
    };
}

